
import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import { TranslationHandler } from '../mixins/TranslationHandler'
import { Getter } from 'vuex-class'
import AssetHow from '../components/AssetHow.vue'
import AssetHowDesktop from '../components/AssetHowDesktop.vue'
import Paragraph from 'umg-components/src/components/atoms/Paragraph.vue'
import Headline from 'umg-components/src/components/atoms/Headline.vue'

@Component({
  components: {
    AssetHow,
    AssetHowDesktop,
    Paragraph,
    Headline,
  },
})
export default class HomeHow extends Mixins(TranslationHandler) {
  @Getter visualFont!: string
  @Getter visualPrimaryColor!: string
  @Getter visualTextColor!: string
  @Getter visualIsDark!: boolean
  @Getter visualParagraphColor!: string

  get translations() {
    return {
      how: {
        title: this.$t('howTitle'),
        text: this.$t('howText'),
        titleStep1: this.$t('howTitleStep1'),
        titleStep2: this.$t('howTitleStep2'),
        titleStep3: this.$t('howTitleStep3'),
        textStep1: this.$t('howTextStep1'),
        textStep2: this.$t('howTextStep2'),
        textStep3: this.$t('howTextStep3'),
      },
    }
  }
}
